import { object, string } from "yup";

export const NewPaymentTypeSchema = object({
  name: string().required("Задолжително"),
});
